class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.addEventListeners();  // 添加事件监听
  }

  addEventListeners() {
    // 如果有 is-hover 属性，监听鼠标事件
    if (this.hasAttribute('is-hover')) {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }

    // 默认的 focusout 和 toggle 行为
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onMouseEnter() {
    // 鼠标移入时，如果设置了 is-hover 属性，打开详情
    if (this.hasAttribute('is-hover')) {
      this.showHoverContent();
    }
  }

  onMouseLeave() {
    // 鼠标移出时，关闭详情
    if (this.hasAttribute('is-hover')) {
      this.hideHoverContent();
    }
  }

  onToggle() {
    super.onToggle(); // 默认的行为
    if (this.header) {
      this.header.preventHide = this.mainDetailsToggle.open;

      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  onFocusOut() {
    super.onFocusOut(); // 默认的行为
  }

  showHoverContent() {
    // 如果有 is-hover 属性，显示内容
    this.mainDetailsToggle.setAttribute('open', '');  // 打开详情
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  hideHoverContent() {
    // 如果有 is-hover 属性，隐藏内容
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('header-menu', HeaderMenu);
